import type { RuntimeWidgetConfig } from "../config/public-config.types.ts";

export type WidgetState =
  | {
      status: "idle" | "loading";
    }
  | {
      config: RuntimeWidgetConfig;
      status: "ready";
    }
  | {
      reason: string;
      status: "failed";
    };

export type WidgetStore = {
  getState(): WidgetState;
  setFailed(reason: string): void;
  setLoading(): void;
  setReady(config: RuntimeWidgetConfig): void;
  subscribe(listener: (state: WidgetState) => void): () => void;
};

export function createWidgetStore(): WidgetStore {
  let state: WidgetState = { status: "idle" };
  const listeners = new Set<(state: WidgetState) => void>();

  function setState(nextState: WidgetState) {
    state = nextState;
    for (const listener of listeners) {
      listener(state);
    }
  }

  return {
    getState() {
      return state;
    },
    setFailed(reason) {
      setState({ status: "failed", reason });
    },
    setLoading() {
      setState({ status: "loading" });
    },
    setReady(config) {
      setState({ status: "ready", config });
    },
    subscribe(listener) {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
  };
}
